var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.15039,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.15039,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#CCD4DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6504 8.2334C17.3205 8.2334 17.8641 8.77621 17.8643 9.44629V14.7861H23.2031C23.8734 14.7861 24.417 15.3298 24.417 16C24.417 16.6702 23.8733 17.2139 23.2031 17.2139H17.8643V22.5537C17.8641 23.2238 17.3205 23.7666 16.6504 23.7666C15.9803 23.7666 15.4367 23.2238 15.4365 22.5537V17.2139H10.0967C9.42655 17.2138 8.88284 16.6701 8.88281 16C8.88281 15.3298 9.42653 14.7862 10.0967 14.7861H15.4365V9.44629C15.4367 8.77623 15.9803 8.23343 16.6504 8.2334Z",
    fill: "#1D2129"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic_add.79102419f8efc89d4c04c631bf264be2.svg";
export { ForwardRef as ReactComponent };